import styled from 'styled-components';

export const Outer = styled.div`
  padding: 4px 0;
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 500;
  color: #000;
`;

export const Input = styled.input`
  margin-right: 5px;
  border: 1px solid #000;
  border-radius: 0;
`;

export const Count = styled.span`
  font-weight: 600;
  margin-left: 0.5em;
`;
